import { api, handleError } from "./baseApi";

export async function getCustomer(filters = {}) {
  try {
    const params = { ...filters };
    Object.keys(params).forEach((key) => {
      if (params[key] === "" || params[key] == null) {
        delete params[key];
      }
    });

    const { data } = await api.get("/customer", { params });
    return data;
  } catch (error) {
    return handleError(error, "Failed to fetch customers");
  }
}
export async function getCustomerById(customerId) {
  try {
    const { data } = await api.get(`/customer/${customerId}`);
    return data;
  } catch (error) {
    return handleError(error, "Failed to fetch customer by ID");
  }
}

export async function deleteCustomerById(customerId) {
  try {
    const { data } = await api.delete(`/customer/${customerId}`);
    return data;
  } catch (error) {
    return handleError(error, "Failed to delete customer");
  }
}

export async function updateCustomerById(customerId, updateData) {
  try {
    const { data } = await api.put(`/customer/${customerId}`, updateData);
    return data;
  } catch (error) {
    return handleError(error, "Failed to update customer");
  }
}

export async function searchCustomerByPhone(phone_number) {
  try {
    const { data } = await api.get("/customer/search", {
      params: { phone_number },
    });
    return data;
  } catch (error) {
    return handleError(error, "Failed to search customer by phone");
  }
}
